import { INotificationsData, INotificationsAction, INotificationsPage } from 'models/notifications/notifications';
import * as c from 'models/constants';
import { IStore } from '../../../IStore';
import { markPageNotificationsAsViewed } from '../notificationspage';

/** Action Types */
export const REQUEST_START: string = 'notificationsdropdown/REQUEST_START';
export const REQUEST_FAILURE: string = 'notificationsdropdown/REQUEST_FAILURE';
export const GET_NOTIFICATIONS_SUCCESS: string = 'notificationsdropdown/GET_NOTIFICATIONS_SUCCESS';
export const CHANGE_SELECTED_TAB: string = 'notificationsdropdown/CHANGE_SELECTED_TAB';
export const RESET_DATA: string = 'notificationsdropdown/RESET_DATA';
export const SET_ISFIRSTLOAD: string = 'notificationsdropdown/SET_ISFIRSTLOAD';
export const SET_ITEMS_PAGE: string = 'notificationsdropdown/SET_ITEMS_PAGE';
export const SET_NUMBER_OF_NOT_VIEWED_NOTIFICATIONS: string =
	'notificationsdropdown/SET_NUMBER_OF_NOT_VIEWED_NOTIFICATIONS';

/** Initial State */
const initialState: INotificationsData = {
	isFetching: false,
	selectedTab: c.NOTIFICATIONS_TAB_USER,
	items: [],
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
		totalItemsUnread: 0,
	},
	isFirstLoad: false,
	numberOfNotViewedNotifications: 0,
};

/** Reducer */
export function notificationsDropdownReducer(state = initialState, action: INotificationsAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
			});

		case GET_NOTIFICATIONS_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				message: action.payload.message,
				error: true,
			});

		case CHANGE_SELECTED_TAB:
			return Object.assign({}, state, {
				selectedTab: action.payload.selectedTab,
			});

		case SET_ITEMS_PAGE:
			return Object.assign({}, state, {
				itemsPage: action.payload.itemsPage,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				items: [],
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
					totalItemsUnread: 0,
				},
			});

		case SET_ISFIRSTLOAD:
			return Object.assign({}, state, {
				isFirstLoad: action.payload.isFirstLoad,
			});

		case SET_NUMBER_OF_NOT_VIEWED_NOTIFICATIONS:
			return Object.assign({}, state, {
				numberOfNotViewedNotifications: action.payload.numberOfNotViewedNotifications,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function changeTabAndGetRequiredData(selectedTab: string) {
	return (dispatch) => {
		let profileOnly: boolean = false;
		let shopOnly: boolean = false;

		switch (selectedTab) {
			case c.NOTIFICATIONS_TAB_USER:
				profileOnly = true;
				break;

			case c.NOTIFICATIONS_TAB_SHOP:
				shopOnly = true;
				break;

			default:
				break;
		}

		dispatch(getNotifications(profileOnly, shopOnly));
		dispatch(changeSelectedTab(selectedTab));
	};
}

/** Action Creator */
export function getNotifications(profileOnly: boolean, shopOnly: boolean) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		let queryString = '?';
		queryString = queryString + '&currentPage=1';
		queryString = queryString + '&itemsPerPage=5';
		queryString = queryString + '&profileOnly=' + profileOnly;
		queryString = queryString + '&shopOnly=' + shopOnly;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/Notifications' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: INotificationsPage) => {
						dispatch(getNotificationsSuccess(res.items));
						dispatch(setItemsPage(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function checkForNewNotifications() {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		let queryString = '?';
		queryString = queryString + '&currentPage=1';
		queryString = queryString + '&itemsPerPage=10';

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/Notifications' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: INotificationsPage) => {
						dispatch(setNumberOfNotViewedNotifications(res.totalItemsUnread));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator - create */
export function notificationView(notificationIds: string[], viewed: boolean = true, viewAll: boolean = false) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		const queryString = '?viewed=' + viewed + '&viewAll=' + viewAll;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/NotificationView' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(notificationIds),
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(markDropdownNotificationsAsViewed(notificationIds, viewAll));
					dispatch(markPageNotificationsAsViewed(notificationIds, viewAll));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function markDropdownNotificationsAsViewed(notificationIds: string[], markAll: boolean = false) {
	return (dispatch, getState: () => IStore) => {
		const notificationsDropdownState: INotificationsData = getState().notificationsDropdown;
		const notifications = notificationsDropdownState.items;

		let numberOfNotViewedNotifications = notificationsDropdownState.numberOfNotViewedNotifications;

		if (markAll) {
			notifications.map((item) => {
				item.viewed = true;
			});
			notifications.map((item) => {
				item.viewed = true;
			});
			numberOfNotViewedNotifications = 0;
		} else {
			notifications.map((item) => {
				if (notificationIds.indexOf(item.id) > -1) {
					item.viewed = true;
				}
			});
			notifications.map((item) => {
				if (notificationIds.indexOf(item.id) > -1) {
					item.viewed = true;
				}
			});
			numberOfNotViewedNotifications = numberOfNotViewedNotifications - notificationIds.length;
		}

		dispatch(getNotificationsSuccess(notifications));
		dispatch(setNumberOfNotViewedNotifications(numberOfNotViewedNotifications));
	};
}

/** Action Creator */
export function requestStart(): INotificationsAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function getNotificationsSuccess(items: any[]): INotificationsAction {
	return {
		type: GET_NOTIFICATIONS_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): INotificationsAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function changeSelectedTab(selectedTab: string): INotificationsAction {
	return {
		type: CHANGE_SELECTED_TAB,
		payload: {
			selectedTab,
		},
	};
}

/** Action Creator */
export function resetData(): INotificationsAction {
	return {
		type: RESET_DATA,
	};
}

export function setIsFirstLoad(isFirstLoad: boolean): INotificationsAction {
	return {
		type: SET_ISFIRSTLOAD,
		payload: {
			isFirstLoad,
		},
	};
}

/** Action Creator */
export function setItemsPage(itemsPage: INotificationsPage): INotificationsAction {
	return {
		type: SET_ITEMS_PAGE,
		payload: {
			itemsPage,
		},
	};
}

/** Action Creator */
export function setNumberOfNotViewedNotifications(numberOfNotViewedNotifications: number): INotificationsAction {
	return {
		type: SET_NUMBER_OF_NOT_VIEWED_NOTIFICATIONS,
		payload: {
			numberOfNotViewedNotifications,
		},
	};
}
